module.exports = __webpack_public_path__ + "static/media/leaderboard@2x.8c45ed7e.png";